import { useCallback, useEffect, useState } from 'react';
import { Tree } from 'antd';
import {DownOutlined} from '@ant-design/icons';
export const CategoryTree = ({ treeData, setItem, setCateLev, setSelectedItem, tabOption, setTab }) => {
  const [expandedKeys, setExpandedKeys] = useState(['0']);
  const onSelect = (selectedKeys, record) => {
    if (tabOption === '2') {
      setTab('1');
    }
    const selectedLevel = record.node.level;
    if (selectedLevel !== 'book_cate2'){
      setItem(record.node.children)
    }
  };

  const onExpand = (expandedKeysValue) => {
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    fnSetExpandedKeys(expandedKeysValue);
  };

  useEffect(()=>{
    if(expandedKeys[0]==='0'){
      setItem(treeData[0]?.children)
    }
  },[treeData])


  const fnSetExpandedKeys = useCallback((expandedKeys)=>{
        setExpandedKeys(expandedKeys);
  },[])

  return <Tree
            showIcon
            defaultSelectedKeys={expandedKeys}
            defaultExpandedKeys={expandedKeys}
            expandedKeys={expandedKeys}
            switcherIcon={<DownOutlined />}
            treeData={treeData}
            onSelect={onSelect}
            onExpand={onExpand}
            className="book-category-tree"
          />
};
